import { render, staticRenderFns } from "./WDGFileList.vue?vue&type=template&id=239cbaae&"
import script from "./WDGFileList.vue?vue&type=script&lang=js&"
export * from "./WDGFileList.vue?vue&type=script&lang=js&"
import style0 from "./WDGFileList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports